import React from 'react'
import { useDispatch } from 'react-redux'
import { setKambiClientVisibility } from '@core/Areas/KambiClient/Store'
import { toggleKambiVisibility } from '@core/Areas/KambiClient/helpers/visibility'

export const useToggleKambiClientVisibility = (isEnabled: boolean): void => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    dispatch(setKambiClientVisibility(isEnabled))
    toggleKambiVisibility(isEnabled)

    return () => {
      dispatch(setKambiClientVisibility(false))
      toggleKambiVisibility(false)
    }
  }, [isEnabled, dispatch])
}
